const baseUrls = {
    map: 'https://map.verseworld.com',
    login: 'https://account.verseworld.com',
    account: 'https://account.verseworld.com',
    download: 'https://download.verseworld.com',
    default: 'https://verseworld.com',
};

export default baseUrls;